import type { CanonicalStage } from '@capture/shared';
import { formatStageLabel } from '@capture/shared';

export interface StageCardProps {
  stage: CanonicalStage;
  enabled: boolean;
  required: boolean;
  selected: boolean;
  onSelect: () => void;
  onToggle: () => void;
}

export function StageCard({ stage, enabled, required, selected, onSelect, onToggle }: StageCardProps) {
  const cls = [
    'stage-card',
    enabled ? 'enabled' : 'disabled',
    selected ? 'selected' : '',
    required ? 'required' : '',
  ].filter(Boolean).join(' ');

  return (
    <button
      type="button"
      data-testid={`stage-card-${stage}`}
      className={cls}
      onClick={onSelect}
    >
      <div className="stage-badge">{required ? 'Required' : enabled ? 'Optional · On' : 'Optional · Off'}</div>
      <div className="stage-name">{formatStageLabel(stage)}</div>
      {required ? (
        <span className="stage-lock" aria-hidden="true">🔒</span>
      ) : (
        <button
          type="button"
          aria-label={`${enabled ? 'Disable' : 'Enable'} ${formatStageLabel(stage)}`}
          data-test="toggle"
          className="stage-toggle"
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
        />
      )}
    </button>
  );
}
